import { StoreModel } from '../../models/Index';

export default function receiptAttributes(Store: StoreModel) {
    return Store.receiptAttributes;
}
